import { useState } from "react";
import { addSavedVehicle, getSavedVehicles, SavedVehicle } from "../vehicleHistory.js";

export interface RecentVehiclesListProps {
  vehicleAction: (vehicle: SavedVehicle) => void;
}

export function RecentVehiclesList({ vehicleAction }: RecentVehiclesListProps) {

  const [savedVehicles, setSavedVehicles] = useState<SavedVehicle[]>(getSavedVehicles());


  function handleSavedVehicleClick(vehicle: SavedVehicle) {
    // Save the selection and update state
    addSavedVehicle(vehicle);
    setSavedVehicles(getSavedVehicles());

    return vehicleAction(vehicle);
  }

  return (
  <div className="gbs-saved-vehicles">
    {savedVehicles.length ? (
    <ul className="gbs-saved-vehicles-list">
      {savedVehicles.map((vehicle, index) => (
        <li key={index}>
          <button type="button" className="gbs-saved-vehicle-button" onClick={() => handleSavedVehicleClick(vehicle)}>
            {vehicle.year} {vehicle.makeName} {vehicle.modelName}
          </button>
        </li>
      ))}
    </ul>
    ) : (
    <div className="gbs-no-saved-vehicles">
      No recent vehicles.
      Choose your vehicle above.
    </div>
    )}
  </div>
  )
}